"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var getSalaryValue = function(item) {
    return Number(item.dataset.salary.replace(/\D/g, ""));
};
function sortList(list) {
    var _list;
    var items = _to_consumable_array(list.children);
    items.sort(function(a, b) {
        return getSalaryValue(b) - getSalaryValue(a);
    });
    (_list = list).append.apply(_list, _to_consumable_array(items));
}
function getEmployees(list) {
    var items = _to_consumable_array(list.children);
    var getObjectEmployee = function(item) {
        return {
            name: item.textContent.trim(),
            position: item.dataset.position,
            salary: getSalaryValue(item),
            age: Number(item.dataset.age)
        };
    };
    var rightObjectEmployees = items.map(getObjectEmployee);
    return rightObjectEmployees;
}
var listEmployee = document.querySelector("ul");
sortList(listEmployee);
getEmployees(listEmployee);

//# sourceMappingURL=index.a4eef698.js.map
